// Datos compartidos de tratamientos de Amarme Skin Studio
export const TREATMENTS = [
  {
    slug: "limpieza-purificante",
    title: "Limpieza Facial Purificante",
    minutes: 90,
    duration: "90 min",
    tagline: "Para piel congestionada, poros obstruidos, exceso de grasa o brotes",
    description:
      "Realizamos una limpieza profunda acompañada de exfoliación, extracciones y activos calmantes para dejar la piel más limpia, fresca y equilibrada.",
    benefits: [
      "Reduce puntos negros",
      "Mejora textura",
      "Ayuda a controlar la grasa",
      "Deja la piel más luminosa",
    ],
    concerns: ["Acné", "Textura", "Glow"],
    image:
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&w=900&q=80",
  },
  {
    slug: "hydraglow",
    title: "Ritual Hydraglow",
    minutes: 90,
    duration: "90 min",
    tagline: "Hidratación profunda y renovación suave",
    description:
      "Tratamiento de hidratación profunda y renovación suave que limpia, exfolia e infunde activos específicos según las necesidades de tu piel.",
    idealFor: [
      "Deshidratación",
      "Piel opaca",
      "Textura irregular",
      "Glow antes de eventos",
    ],
    result:
      "Piel más luminosa, suave y revitalizada desde la primera sesión.",
    concerns: ["Deshidratación", "Glow", "Piel sensible"],
    image:
      "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?auto=format&fit=crop&w=900&q=80",
  },
  {
    slug: "dermapen-regenerador",
    title: "Dermapen Regenerador",
    minutes: 75,
    duration: "75 min",
    tagline: "Bioestimulación con microcanales controlados",
    description:
      "Tratamiento de bioestimulación que ayuda a mejorar marcas, manchas, líneas finas y textura mediante microcanales controlados.",
    idealFor: [
      "Cicatrices de acné",
      "Poros visibles",
      "Manchas postinflamatorias",
      "Envejecimiento temprano",
    ],
    benefits: [
      "Estimula colágeno",
      "Mejora firmeza",
      "Unifica la piel",
      "Aporta luminosidad",
    ],
    note: "Puede generar enrojecimiento leve por 24–48 hrs.",
    concerns: ["Manchas", "Textura", "Envejecimiento", "Acné"],
    image:
      "https://images.unsplash.com/photo-1612817288484-6f916006741a?auto=format&fit=crop&w=900&q=80",
  },
  {
    slug: "peeling-renovador",
    title: "Peeling Renovador",
    minutes: 60,
    duration: "60 min",
    tagline: "Exfoliación profesional progresiva y segura",
    description:
      "Exfoliación profesional diseñada para renovar la piel de forma progresiva y segura. Cada protocolo se personaliza según la sensibilidad y necesidades de la piel.",
    helpsWith: ["Manchas", "Acné", "Textura", "Opacidad", "Signos de envejecimiento"],
    concerns: ["Manchas", "Acné", "Envejecimiento", "Textura"],
    image:
      "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?auto=format&fit=crop&w=900&q=80",
  },
];

export const CONCERNS = [
  "Acné",
  "Manchas",
  "Piel sensible",
  "Glow",
  "Envejecimiento",
  "Deshidratación",
  "Textura",
];

export const FAQS = [
  {
    q: "¿Duele?",
    a: "La mayoría de nuestros tratamientos son indoloros o generan solo una sensación leve. En tratamientos como Dermapen aplicamos anestésico tópico antes para mayor comodidad.",
  },
  {
    q: "¿Cuánto dura el resultado?",
    a: "Depende del tratamiento. Una Limpieza Facial Purificante mantiene la piel renovada por 3–4 semanas, mientras que protocolos como Dermapen o Peeling acumulan resultados visibles después de 3–6 sesiones.",
  },
  {
    q: "¿Puedo maquillarme después?",
    a: "En limpiezas e hidrataciones puedes maquillarte al día siguiente. En Peelings y Dermapen recomendamos esperar entre 24 y 48 horas para no irritar la piel.",
  },
  {
    q: "¿Qué cuidados debo tener?",
    a: "Después de cada sesión te entregamos indicaciones personalizadas. Lo esencial: protector solar diario, hidratación y evitar exposición prolongada al sol en las primeras 48 horas.",
  },
  {
    q: "¿Cómo sé qué tratamiento elegir?",
    a: "Si tienes dudas puedes reservar una evaluación personalizada. Analizamos tu piel y diseñamos el protocolo ideal para tus objetivos.",
  },
];

export const findTreatment = (slug) =>
  TREATMENTS.find((t) => t.slug === slug);
